module.exports = __webpack_public_path__ + "static/img/4.ada6d9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/4.png
// module id = EtfN
// module chunks = 216